import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export interface AlertWhitelistPayloadItem {
  message: string;
  computerId: string;
  computerName: string;
  process?: string;
  processUser?: string;
  level?: string;
  enabled?: boolean;
}

export interface InfluxAlertWhitelisting {
  id?: string | number;
  whitelistId?: string | number;
  message: string;
  computerId: string;
  computerName: string;
  process?: string;
  Process?: string;
  processUser?: string;
  ProcessUser?: string;
  user?: string;
  level?: string;
  enabled?: boolean;
  createdBy?: string;
  createdAt?: string;
  updatedBy?: string;
  isEnabled?: boolean;
  isFlagged?: boolean;
  [key: string]: unknown;
}

export interface ToggleAlertWhitelistPayload {
  id?: string | number;
  whitelistId?: string | number;
  message: string;
  computerId: string;
  computerName: string;
  process?: string;
  processUser?: string;
  level?: string;
  enabled: boolean;
}

export const getAlertsData = async (
  email: string,
  tenantName: string,
  bucket: string,
  filterPagination: string,
  computerName: string,
  computerId: string,
  computeremail: string,
  key: string,
  fromDetails: boolean = false
): Promise<Object | undefined> => {
  try {
    if (!email || !tenantName) {
      console.error("Email or Tenant Name is missing");
      return
    };
    let url = `${NGROK}/api/influxdb/influxdblogsdata?bucketName=${bucket}&timingMode=${filterPagination}&email=${email}`;
    url += "&limitNeeded=false";

    if (computeremail !== null && computeremail.length > 0) {
      url += `&computer_email=${computeremail}`;
    }
    if (computerName !== null && computerName.length > 0) {
      url += `&computerName=${computerName}`;
    }

    if (computerId !== null && computerId.length > 0) {
      url += `&computerId=${encodeURIComponent(computerId)}`;
    }

    if (tenantName !== null) {
      url += `&tenantName=${tenantName}`;
    }
    if (fromDetails) {
      url += `&fromdetails=true`;
      key = computerName;
    }
    return await apiClient<Object>({
      method: "GET",
      url
    });
  } catch (error) {
    console.error("saveToken error:", error);
  }
};

export const submitWhitelistedAlerts = async (
  payload: AlertWhitelistPayloadItem[],
  tenantName: string
): Promise<object> => {
  const url = `${NGROK}/api/influxdb/alert-whitelisting`;

  return await apiClient<object>({
    method: "POST",
    url,
    data: payload,
    params: {
      tenantName,
    },
  });
};

export const getAlertWhitelistedList = async (
  tenantName: string,
  searchparams: string = "",
  computerId: string = "-1",
  computeremail: string = ""
): Promise<InfluxAlertWhitelisting[]> => {
  const url = `${NGROK}/api/influxdb/alert-whitelists`;

  return await apiClient<InfluxAlertWhitelisting[]>({
    method: "GET",
    url,
    params: {
      tenantName,
      searchparams,
      computerId,
      userEmail: computeremail,
    },
  });
};

export const toggleAlertWhitelistStatus = async (
  tenantName: string,
  payload: ToggleAlertWhitelistPayload
): Promise<object> => {
  const url = `${NGROK}/api/influxdb/alert-whitelisting`;

  return await apiClient<object>({
    method: "POST",
    url,
    data: payload,
    params: {
      tenantName,
    },
  });
};